import React from "react";
import {Badge, Button, Table} from "antd"
import connect from "react-redux/es/connect/connect";
import UpdateGroupRowDrawer from "./update/SelectionGroupRowUpdateDrawer"


class SelectionRowBuilderTable extends React.Component {
    static propTypes = {};

    state = {
        showUpdateGroupRowDrawer: false,
        record: null
    };

    onEdit = (record) => {
        this.setState(state => ({showUpdateGroupRowDrawer: !state.showUpdateGroupRowDrawer, record:record.id}))
    };

    toggleUpdateDrawer = () => this.setState(state => ({showUpdateGroupRowDrawer: !state.showUpdateGroupRowDrawer}));

    render() {
        const {showUpdateGroupRowDrawer, record} = this.state;
        const {selection, isAdmin} = this.props;
        const toEdit = this.props.recordItem.rows.filter(x => x.id === record)[0] || {};

        const columns = [
            {title: 'Active',
                dataIndex: 'data.row_active',
                filters: [
                    {text: 'Active', value: 1},
                    {text: 'Deactive', value: 2},
                ],
                onFilter: (value, record) => record.row_active === value,
                // eslint-disable-next-line
                render: active => <Badge status={active == 1 ? 'success' : 'default'}/>,
                width: 85},
            {title: 'Person Type', dataIndex: 'data.persType'},
            {title: 'Education', dataIndex: 'data.education'},
            {title: 'Position', dataIndex: 'data.position'},
            {title: 'Working Specialty', dataIndex: 'data.workingSpecialty'},
            {
                title: 'Site Type', dataIndex: 'data.siteType'
            },
            {title: 'Site Specialty', dataIndex: 'data.siteSpeciality'},
            {title: 'Postal Code', render: (record) => {
                var siteZipFrom = record.data.siteZipFrom
                var siteZipTo = record.data.siteZipTo
                return siteZipFrom + ' - ' + siteZipTo
                }},
            {title: 'Persons', dataIndex: 'count'},
            {title: 'Sites', dataIndex: 'siteCount'},
            {
                title: '', render: (record) => <div className="crud-options">
                    <Button disabled={!isAdmin} icon="edit" size="small" shape="circle" onClick={e => this.onEdit(record)}/>
                </div>
            }
        ];
        return <div>
            <Table dataSource={this.props.recordItem.rows} rowkey="uuid"
                   columns={columns} size="small" bordered
                   pagination={false}
            />

            {showUpdateGroupRowDrawer && <UpdateGroupRowDrawer
                visible={showUpdateGroupRowDrawer}
                toEdit={toEdit.data}
                populate={selection.selectionGroupCreationData}
                toggleVisibility={this.toggleUpdateDrawer}
            />}
        </div>

    }
}


const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({});


export default connect(mapStateToProps, mapDispatchToProps)(SelectionRowBuilderTable)



// WEBPACK FOOTER //
// ./src/js/selection/SelectionRowBuilderTable.js